export default __webpack_public_path__ + "static/media/blob3.e2cfa266.svg";